import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getParentElementWithChildren } from "@whalecloud/page-builder-core/selectors";
import { Collapse } from '@whalecloud/fdx';
import { toolCollapseAttr } from '@utils/util';
import CommonStyleSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonStyleSettings';
import { getLocale, defaultTarget } from '@utils/util';

const { Panel } = Collapse;
const TextSettings = ({ element, parentElement, updateElement }) => {
  const messages = getLocale();
  return (
    <Collapse {...toolCollapseAttr} defaultActiveKey={['1']}>
      <Panel header={messages['PAGEBUIDER_SETTINGS']} key="1">
        <CommonStyleSettings />
      </Panel>
    </Collapse>
  );
};

export default connect<any, any, any>(
  (state, { element }) => {
    return { parentElement: getParentElementWithChildren(state, element.id) }
  }
)(React.memo(TextSettings));
